.chevron {
  // not a fan, but the alternative is a refactor of the dropdown component
  width: 16px !important;
}
